
import previewModel from "../models/previewModel";
import AnalyticsSender from "./analyticsSender";
import { createImage } from '../helpers/canvasHelpers';

export const addImage = (
  image: File, service, sendErrorSizeImage, sendAddError,
  sendAddImage, setImage, setDimension, setError, clearError, dispatch, canvasRef,
  imageFormat, changeImage
  
) => {
  setImage(
    image,
    service,
    sendErrorSizeImage,
    sendAddError,
    sendAddImage,
    setImage,
    setDimension,
    setError,
    dispatch,
    clearError
  );

  createImage(URL.createObjectURL(image)).then((image) => {
    if (canvasRef) {
      const context = canvasRef.getContext("2d");
      context.drawImage(image, 0, 0);

      changeImage(canvasRef.toDataURL(imageFormat));
    }
  });

};


export const loadImage = (
  image, imageElement, service, setError, sendErrorSizeImage,
  sendAddError, sendAddImage, setImage, setDimension, dispatch, clearError  
) => {
  const width = imageElement.naturalWidth;
  const height = imageElement.naturalHeight;

  dispatch(clearError());

  if (width > 12000 || height > 12000) {
    dispatch(setError('notSizeValid'));

    if (service === 'rotator' || service === 'flipper') {
      sendErrorSizeImage();
    } else {
      sendAddError('not_size_valid');
    }

  } else {
    sendAddImage(image.type, width, height);

    const imageAction = setImage(image);
    const dimensionAction = setDimension(height, width)

    dispatch(imageAction.setImage);
    dispatch(imageAction.setName);
    dispatch(imageAction.setFormat);
    dispatch(dimensionAction.image);
    dispatch(dimensionAction.canvas);
  }
}


//ToDo Refactoring
export const acceptImageTypes = [
  {
    type: 'image/jpeg',
    name: 'JPEG'
  },
  {
    type: 'image/jpg',
    name: 'JPG'
  },
  {
    type: 'image/png',
    name: 'PNG'
  },
]
const analyticsSender = new AnalyticsSender();
export function withoutFormat(fileName: string): string {
  const formats: string[] = acceptImageTypes.map(type => (type.name).toLocaleLowerCase());

  const regex: RegExp = new RegExp(`.(${formats.join("|")})$`, 'gi');

  return fileName.replace(regex, "");
}

export function changeDimension(
  modifiedProps: string,
  inputDimension: { height: number; width: number },
  imageDimension: { height: number; width: number },
  isSaveProperties: boolean
) {
  if (!isSaveProperties) return inputDimension;

  const proportionFromOriginal =
    imageDimension[modifiedProps] / inputDimension[modifiedProps];

  return {
    height: Math.round(imageDimension.height / proportionFromOriginal),
    width: Math.round(imageDimension.width / proportionFromOriginal),
  };
}

export function resizeImage(
  modifiedProps: string,
  inputWidth: number | undefined,
  inputHeight: number | undefined,
  warningWidth: any,
  warningHeight: any,
  imageWidth: number | undefined,
  imageHeight: number | undefined,
  isPreservationProportions: boolean,
  changeDimension: Function,
  canvasSetDimension: Function,
  validateDimention: Function,
  setWarningWidth: Function,
  setWarningHeight: Function,
  setInputWidthValue: Function,
  setInputHeightValue: Function) {
  setInputWidthValue(inputWidth)
  setInputHeightValue(inputHeight)

  if (warningWidth) setWarningWidth("");
  if (warningHeight) setWarningHeight("");

  const validateWidth = validateDimention("width", inputWidth);
  const validateHeight = validateDimention("height", inputHeight);

  if (validateWidth.isValid && validateHeight.isValid) {

    const changedDimention = changeDimension(
      modifiedProps,
      { width: inputWidth, height: inputHeight },
      { width: imageWidth, height: imageHeight },
      isPreservationProportions
    );

    const validateChangedWidth = validateDimention(
      "width",
      changedDimention.width
    );
    const validateChangeHeight = validateDimention(
      "height",
      changedDimention.height
    );

    if (validateChangedWidth.isValid && validateChangeHeight.isValid) {
      analyticsSender.sendChangeDimensiom(changedDimention.width, changedDimention.height, modifiedProps);
      canvasSetDimension(changedDimention.height, changedDimention.width);

      setInputWidthValue(changedDimention.width)
      setInputHeightValue(changedDimention.height)

    } else {
      setWarningWidth(!validateChangedWidth.isValid ? validateChangedWidth.type : "");
      setWarningHeight(!validateChangeHeight.isValid ? validateChangeHeight.type : "");
      analyticsSender.sendErrorChangeDimensiom(changedDimention.width, changedDimention.height, modifiedProps);
    }
  } else {
    setWarningWidth(!validateWidth.isValid ? validateWidth.type : "");
    setWarningHeight(!validateHeight.isValid ? validateHeight.type : "");
    analyticsSender.sendErrorChangeDimensiom(inputWidth, inputHeight, modifiedProps);
  }
}


const imageHelper = () => {
  const getDefaultPreviewImage = (presetDemention: { width: number, height: number }, column: number, image: string, title: string, description: string, cssHeight: number, left: number = 0, top: number = 0): previewModel => {
    return {
      width: presetDemention.width,
      height: presetDemention.height,
      top: top,
      let: left,
      column: column,
      previewUrl: image,
      isChecked: false,
      previewChangeUrl: '',
      title: title,
      description: description,
      cssHeight: cssHeight

    }
  }

  return { getDefaultPreviewImage }
}


export const downloadImage = (base64Data: string, fileName: string) => {
  const linkSource = base64Data;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};


export const resizeImagePreview = (imageWidth, imageHeight, itemWidth, itemHeight) => {
  const imageWidthProperties = imageWidth / itemWidth;
  const imageHeightProperties = imageHeight / itemHeight;

  const resizeProperties =
    imageWidthProperties < imageHeightProperties
      ? imageWidthProperties
      : imageHeightProperties;

  return {
    width: imageWidth / resizeProperties,
    height: imageHeight / resizeProperties,
  };
};


export default imageHelper;
